import { DetalhesAnatomia3D } from '../anatomia/DetalhesAnatomia3D'
import { ancoraPorId } from '../../dominio/didatico/perfilVeiculo'
import { perfilVitimaPorId } from '../../dominio/didatico/perfisVitima'
import { POSE_SENTADA, colocacaoNaAncora } from '../../dominio/didatico/rigVitima'
import { useMaquete } from '../componentes/contextoMaquete'
import { VitimaProcedural } from '../vitima/VitimaProcedural'
import { VeiculoDidatico } from './VeiculoDidatico'
import { EstruturaComparativa } from './EstruturaComparativa'
import type { TipoEstruturaVeicular } from '../../dominio/didatico/tiposEstruturaVeicular'
import type { EstadoTetoLateral } from '../../dominio/didatico/rebatimentoLateralTeto'
import type { EstadoElevacaoPainel } from '../../dominio/didatico/elevacaoPainel'
import type { EstadoRebatimentoPainel } from '../../dominio/didatico/rebatimentoPainel'
import type { IdPortaOficina } from '../oficina/zonasOperacaoPorta'
import type { EstadoPortaOficina, OperacaoPorta } from '../../dominio/didatico/oficinaCorte'
import type { EstadoTampaOficina } from '../../dominio/didatico/oficinaPortaMalas'
import type { EstadoTerceiraPortaOficina } from '../../dominio/didatico/oficinaTerceiraPorta'

export interface PropsCenaMaquete {
  mostrarDetalhesAnatomia?: boolean
  idPerfilVitima: string
  idAncora: string
  mostrarVitima: boolean
  mostrarEixoColuna: boolean
  tipoEstrutura: TipoEstruturaVeicular
  mostrarComparacaoEstrutural: boolean
  oficinaPorta?: {
    id: 'portaDianteiraEsquerda' | 'portaDianteiraDireita' | 'portaTraseiraEsquerda' | 'portaTraseiraDireita'
    estado: EstadoPortaOficina
    /** Progresso da saída da porta retirada, de 0 a 1. */
    progressoSaida: number
    progressoAcao?: number
    operacaoVisual?: OperacaoPorta
  }
  oficinaTampa?: {
    estado: EstadoTampaOficina
  }
  oficinaTerceiraPorta?: {
    lado: 'esquerdo' | 'direito'
    estado: EstadoTerceiraPortaOficina
  }
  oficinaExtensor?: {
    deslocamentoPainel: number
    rebatimento?: EstadoRebatimentoPainel
    elevacao?: EstadoElevacaoPainel
    tetoLateral?: EstadoTetoLateral
    idPorta?: IdPortaOficina
  }
}

/** Cena de exploração: o veículo desmontável com a vítima sentada na âncora. */
export function CenaMaquete(props: PropsCenaMaquete) {
  const { perfil } = useMaquete()
  const ancora = ancoraPorId(perfil, props.idAncora)

  return (
    <group>
      <VeiculoDidatico
        perfil={perfil}
        detalhesAnatomia={props.mostrarDetalhesAnatomia}
        destaqueSuspensao={props.mostrarComparacaoEstrutural}
        mostrarMecanica
        mostrarEnergia
        oficinaPorta={props.oficinaPorta}
        oficinaTampa={props.oficinaTampa}
        oficinaTerceiraPorta={props.oficinaTerceiraPorta}
        oficinaExtensor={props.oficinaExtensor}
      />
      {props.mostrarDetalhesAnatomia && <DetalhesAnatomia3D perfil={perfil} />}
      {props.mostrarComparacaoEstrutural && <EstruturaComparativa perfil={perfil} tipo={props.tipoEstrutura} />}
      {props.mostrarVitima && (
        <VitimaProcedural
          proporcoes={perfilVitimaPorId(props.idPerfilVitima)}
          colocacao={colocacaoNaAncora(ancora)}
          pose={POSE_SENTADA}
          mostrarEixoColuna={props.mostrarEixoColuna}
        />
      )}
    </group>
  )
}

